import officeImage from "../../image/my office.jpg"
import Aos from "../aos/aos";
import { Link } from "react-router-dom";

const ServicesHero = () => {
    Aos(2000)
    return (
        <div className="flex flex-col md:flex-row space-y-4  bg-black/30 rounded-lg md:space-x-8 md:space-y-0 w-full h-[600px]  md:h-[550px]">

            <div data-aos="fade-down" className="md:h-full md:ml-8 h-[40%] flex flex-col items-center justify-center space-y-8 w-full md:w-[50%] py-2 px-2">
                <div className="text-center text-white md:text-2xl font-mono">
                    All my services are the best of all. Bring your project to me today and you will forever be happy you did</div>
                <Link reloadDocument to="/hireMe" className="bg-yellow-500 animate-bounce hover:animate-none py-2 px-2 text-white rounded-lg hover:bg-black/30 hover:border" data-aos="fade-left">Hire Me</Link>
            </div>
            <div data-aos="fade-up" className="md:h-full md:ml-8 h-[60%] flex flex-col items-center justify-center space-y-2 w-full md:w-[50%] py-2 px-2">
                <img src={officeImage} alt="officeimage" className=" h-full w-full rounded-lg" />
            </div>



        </div>
    );
}

export default ServicesHero;